import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: 'event-registration/:eventId',
    loadChildren: () => import('./event-registration/event-registration.module').then(m => m.EventRegistrationModule)
  },
  {
    path: 'opella-registration',
    loadChildren: () => import('./opella-registration/opella-registration.module').then(m => m.OpellaRegistrationModule)
  },
  // DEVW-8192. Вход по ссылке на дистанционный визит: uniqueId активности вида ACT-<GUID>
  {
    path: 'remote-visit/:uniqueId',
    loadChildren: () => import('./remote-visit/remote-visit.module').then(m => m.RemoteVisitModule)
  },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
